import { Navbar } from "../../components/user-components/NavigationBar/Navbar";
import { Contactme } from "../../components/user-components/Contactme/Contactme";
import { Projectme } from "../../components/user-components/Projectme/Projectme";
import { ScrollTop } from "../../config/ScrollTop";
import { ProjectHead } from "../../components/user-components/Header/ProjectHead";

export const Explore = () => {
  
  return (
    <>
      <Navbar />
      <div id="Projects2"></div>
      <ProjectHead />
      <div className="pt-5 pb-10">
        <Projectme />
      </div>
      <div className="py-10">
        <Contactme />
      </div>
      <ScrollTop />
    </>
  );
};
